var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73475 5.91204C3.8572 7.04095 3.33464 8.45949 3.33464 10.0001C3.33464 11.5407 3.8572 12.9592 4.73475 14.0881L6.52497 12.2979C6.0887 11.6392 5.83464 10.8493 5.83464 10.0001C5.83464 9.15085 6.0887 8.36095 6.52497 7.70226L4.73475 5.91204ZM5.91327 4.73353L7.70348 6.52375C8.36217 6.08748 9.15207 5.83342 10.0013 5.83342C10.8505 5.83342 11.6404 6.08748 12.2991 6.52375L14.0893 4.73353C12.9604 3.85598 11.5419 3.33341 10.0013 3.33341C8.46071 3.33341 7.04217 3.85598 5.91327 4.73353ZM15.2679 5.91205L13.4776 7.70226C13.9139 8.36095 14.168 9.15085 14.168 10.0001C14.168 10.8493 13.9139 11.6392 13.4776 12.2979L15.2679 14.0881C16.1454 12.9592 16.668 11.5407 16.668 10.0001C16.668 8.45949 16.1454 7.04095 15.2679 5.91205ZM14.0893 15.2666L12.2991 13.4764C11.6404 13.9127 10.8505 14.1667 10.0013 14.1667C9.15207 14.1667 8.36217 13.9127 7.70348 13.4764L5.91327 15.2666C7.04217 16.1442 8.46071 16.6667 10.0013 16.6667C11.5419 16.6667 12.9604 16.1442 14.0893 15.2666ZM1.66797 10.0001C1.66797 5.39771 5.39893 1.66675 10.0013 1.66675C14.6037 1.66675 18.3346 5.39771 18.3346 10.0001C18.3346 14.6025 14.6037 18.3334 10.0013 18.3334C5.39893 18.3334 1.66797 14.6025 1.66797 10.0001ZM7.5013 10.0001C7.5013 11.3808 8.62059 12.5001 10.0013 12.5001C11.382 12.5001 12.5013 11.3808 12.5013 10.0001C12.5013 8.61937 11.382 7.50008 10.0013 7.50008C8.62059 7.50008 7.5013 8.61937 7.5013 10.0001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d89c1b3aea0718d870c8c75c923ca93f.svg";
export { ForwardRef as ReactComponent };